import { trackEvent } from "@/utils/tracking";
import { digitsOnly, PHONE_DESK_DIGITS } from "@/utils/whatsappHref";
import WhatsAppBrandIcon from "@/components/WhatsAppBrandIcon";

/**
 * WhatsApp shortcut for a phone that has the same digits as tel: — hidden for desk landline.
 * @param {{ telHref: string, trackingChannel?: string, iconClassName?: string, className?: string }} props
 */
export default function WhatsAppTelCompanion({
  telHref,
  trackingChannel = "tel_whatsapp_icon",
  iconClassName = "h-7 w-7 sm:h-8 sm:w-8",
  className = "",
}) {
  const raw = String(telHref || "").replace(/^tel:/i, "");
  const d = digitsOnly(raw);
  if (!d || d === PHONE_DESK_DIGITS) return null;
  const href = `https://wa.me/${d}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      title="WhatsApp"
      className={`inline-flex shrink-0 items-center justify-center rounded-md text-[#25D366] transition-opacity hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#25D366] ${className}`}
      onClick={() =>
        trackEvent("whatsapp_click", {
          channel: trackingChannel,
          phone: d,
        })
      }
    >
      <WhatsAppBrandIcon className={iconClassName} />
    </a>
  );
}
